var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-page',{attrs:{"columns":_vm.columns,"headers":_vm.headers,"show-add-button":false,"sort":"id","descending":true,"title":"Error Logs","icon":"mdi-lock","stateendpoint":"errorLog.errorLogs","actions":_vm.actions,"show-default-action-buttons":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }